export const PENDING_APPROVAL_SUCCESS = "PENDING_APPROVAL_SUCCESS";
export const PENDING_APPROVAL_START = "PENDING_APPROVAL_FETCH_START";
export const PENDING_APPROVAL_FAILED = "PENDING_APPROVAL_FAILED";
